import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./features/userSlice";
import { UserApi } from "./api/User/UserApi";
import { ContactsApi } from "./api/Contacts/ContactsApi";
import { PricingApi } from "./api/Pricing/PricingApi";
import { TemplatesApi } from "./api/Templates/TemplatesApi";
import { CampaignsApi } from "./api/Campaigns/CampaignsApi";
import { BookingApi } from "./api/Bookings/BookingApi";
import { BotApi } from "./api/Bots/BotApi";
import { WhatsAppApi } from "./api/WhatsApp/WhatsAppApi";
import { AddonsApi } from "./api/Addons/AddonsApi";
import { BillingApi } from "./api/Billing/BillingApi";
import { SubscriptionApi } from "./api/Subscription/SubscriptionApi";
import { SystemLogApi } from "./api/SystemLog/SystemLogApi";
import { UserAddonApi } from "./api/UserAddon/UserAddonApi";
import { EnquiryApi } from "./api/Enquiry/EnquiryApi";
import { InboxApi } from "./api/Inbox/InboxApi";

export const store = configureStore({
  reducer: {
    User: UserReducer,
    [UserApi.reducerPath]: UserApi.reducer,
    [ContactsApi.reducerPath]: ContactsApi.reducer,
    [PricingApi.reducerPath]: PricingApi.reducer,
    [TemplatesApi.reducerPath]: TemplatesApi.reducer,
    [CampaignsApi.reducerPath]: CampaignsApi.reducer,
    [InboxApi.reducerPath]: InboxApi.reducer,
    [BookingApi.reducerPath]: BookingApi.reducer,
    [BotApi.reducerPath]: BotApi.reducer,
    [WhatsAppApi.reducerPath]: WhatsAppApi.reducer,
    [AddonsApi.reducerPath]: AddonsApi.reducer,
    [BillingApi.reducerPath]: BillingApi.reducer,
    [SubscriptionApi.reducerPath]: SubscriptionApi.reducer,
    [SystemLogApi.reducerPath]: SystemLogApi.reducer,
    [UserAddonApi.reducerPath]: UserAddonApi.reducer,
    [EnquiryApi.reducerPath]: EnquiryApi.reducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      UserApi.middleware,
      ContactsApi.middleware,
      PricingApi.middleware,
      TemplatesApi.middleware,
      CampaignsApi.middleware,
      BookingApi.middleware,
      BotApi.middleware,
      WhatsAppApi.middleware,
      AddonsApi.middleware,
      BillingApi.middleware,
      SubscriptionApi.middleware,
      SystemLogApi.middleware,
      UserAddonApi.middleware,
      EnquiryApi.middleware,
      InboxApi.middleware,
    ]),
});
